/**
 * Enable drawing ingition on the plane
 * @todo: This is a copy of block/draw-ignition and should be consolidated
 **/
import {placeIgnitionAt} from './place-ignition-at';
import {
    Plane,
    FireCell,
    CanvasClickedEvent
} from '@firesim/simkit-core';
import { TerrainCodes } from './terrain-types';

type IgnitionHandlerParams = {
    plane: Plane<TerrainCodes, FireCell<TerrainCodes>>;
};

const showInstructions = () => {
    console.log('Show instructions is not yet implemented');
}

export class IgnitionHandler {
    _plane: Plane<TerrainCodes, FireCell<TerrainCodes>>;

    constructor({plane}: IgnitionHandlerParams) {
        this._plane = plane;
    }

    _ignitionHandler = (evt: Event) => {
        if(!(evt instanceof CanvasClickedEvent) && !(evt instanceof MouseEvent)) {
            throw new Error('Expected MouseEvent');
        }
        const {clientX, clientY} = evt;
        placeIgnitionAt({x: clientX, y: clientY}, this._plane);
    };

    enablePlaceIgnition() {
        this._plane.addEventListener('click', this._ignitionHandler);
    }

    disablePlaceIgnition() {
        this._plane.removeEventListener('click', this._ignitionHandler);
    }

    enableDrawIgnition() {
        this._plane.addEventListener('pan', this._ignitionHandler);
    }

    disableDrawIgnition() {
        this._plane.removeEventListener('pan', this._ignitionHandler);
    }
};



/**
 * Set a button to draw ignition on the map
 * @param {DOMElement} btn The button to bind ignition to
 * @param {Plane} plane The plane to draw on
 **/
export function setupPlaceIgnitionButton(btn: HTMLButtonElement, plane: Plane<TerrainCodes, FireCell<TerrainCodes>>): void {

    const ignitionHandler = new IgnitionHandler({plane});

	const activeClass = 'btn--on';
	let isClicked = false;
	btn.addEventListener('click', (evt) => {
		evt.preventDefault();

		if(!isClicked) {
			// If this is the first time the ignition is clicked remove the instruction listener
			plane.removeEventListener('click', showInstructions);
			isClicked = true;
		}

		if(btn.classList.contains(activeClass)) {
			btn.classList.remove(activeClass);
            ignitionHandler.disableDrawIgnition();
		} else {
			Array.from(document.querySelectorAll('.btn--on'))
				.forEach((activeButton) => {
				    if(!(activeButton instanceof HTMLButtonElement)) {
                        throw new Error('Expected HTMLButtonElement');
                    }
				    activeButton.click()
                });

		    ignitionHandler.enableDrawIgnition();
			btn.classList.add(activeClass);
		}
	});
}

/**
 * Set a button to draw ignition on the map
 * @param {DOMElement} btn The button to bind ignition to
 * @param {Plane} plane The plane to draw on
 **/
export function setupDrawIgnitionButton(btn: HTMLButtonElement, plane: Plane<TerrainCodes, FireCell<TerrainCodes>>): void {

    const ignitionHandler = new IgnitionHandler({plane});

	const activeClass = 'btn--on';
	let isClicked = false;
	btn.addEventListener('click', (evt) => {
		evt.preventDefault();

		if(!isClicked) {
			// If this is the first time the ignition is clicked remove the instruction listener
			plane.removeEventListener('click', showInstructions);
			isClicked = true;
		}

		if(btn.classList.contains(activeClass)) {
            // @ts-ignore (evt: MouseEvent) _is_ a valid handler for mouse events (which is what pan uses)
		    ignitionHandler.disablePlaceIgnition();
		    ignitionHandler.disableDrawIgnition();
            btn.classList.remove(activeClass);
		} else {
			Array.from(document.querySelectorAll('.btn--on'))
				.forEach((activeButton) => {
				    if(!(activeButton instanceof HTMLButtonElement)) {
                        throw new Error('Expected HTMLButtonElement');
                    }
				    activeButton.click()
                });

            // @ts-ignore (evt: MouseEvent) _is_ a valid handler for mouse events (which is what pan uses)
		    ignitionHandler.enablePlaceIgnition();
		    ignitionHandler.enableDrawIgnition();
            btn.classList.add(activeClass);
		}
	});
}

